import { Box, Typography } from "../../../../Components";
import { Form } from "react-bootstrap";

const FamilyHealth = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const options = [
    {
      id: 1,
      label: "No",
    },
    {
      id: 2,
      label: "Yes",
    },
  ];
  return (
    <div>
      {" "}
      <Typography fontSize="1rem" fontWeight="400" color="#E30020">
        MEDICAL HISTORY
      </Typography>
      <Typography fontSize="1.25rem" fontWeight="500" className="my-3">
        Family Health History
      </Typography>
      <Typography fontSize="0.8rem" fontWeight="300">
        The family's health history can indicate genetic risks. Knowing this
        helps us predict and prevent potential health issues.
      </Typography>
      {options?.map((option, idx) => (
        <>
          <Box
            className="p-3 my-3 cursor-pointer option-wrapper"
            onClick={() => {
              setFieldValue("familyHealth", option?.id);
            }}
            height="100%"
            width="100%"
            borderRadius="0.5rem"
            background={values?.familyHealth === option?.id && "#E30020"}
            border={values?.familyHealth === option?.id && "1px solid #E30020"}
          >
            <Typography
              fontSize=".9rem"
              fontWeight={values?.familyHealth === option?.id && "500"}
              className="heading"
              color={values?.familyHealth === option?.id && "white"}
            >
              {option?.label}
            </Typography>
          </Box>
          {values?.familyHealth === 2 && option?.id === 2 && (
            <>
              <Form.Control
                type="text"
                backgroundColor="#EBEBFF"
                name="familyHealthInput"
                placeholder={
                  " e.g., mother with diabetes, father had heart disease, sibling with asthma"
                }
                className="w-100 fs-6"
                value={values?.familyHealthInput}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={
                  touched.familyHealthInput && !!errors.familyHealthInput
                }
                size="lg"
                autoFocus
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.familyHealthInput}
              </Form.Control.Feedback>
            </>
          )}
        </>
      ))}
    </div>
  );
};

export default FamilyHealth;
